import { format } from 'date-fns';
import { MoneyAmountSchemaType } from '@/api/giftCardBackend/moneyAmount';
import { nb } from 'date-fns/locale';

export const formatCurrency = (
  value: number | MoneyAmountSchemaType,
  { absolute = false }: { absolute?: boolean } = {},
) => {
  const _value = typeof value === 'number' ? value : value.amount;
  const absoluteValue = Math.abs(_value);
  const int = Math.floor(absoluteValue);
  const decimals = Math.round(100 * (absoluteValue - int)) / 100;
  return `${_value < 0 && !absolute ? '-' : ''}${int}${decimals > 0 ? `.${`${decimals}`.substring(2)}`.padStart(2, '0') : ''} kr`;
};

export const formatDate = (date: Date | string | null | undefined): string => {
  return date
    ? format(new Date(date), 'dd.MM.yyyy', {
        locale: nb,
      })
    : '';
};

export const formatTime = (date: Date | string | null | undefined): string => {
  return date
    ? format(new Date(date), 'HH:mm', {
        locale: nb,
      })
    : '';
};
